import { useMemo } from "react";

import { PalAutoComplete, PalPage } from "@palamar/fe-library";
import { useDispatch, useSelector } from "react-redux";

import { Grid } from "@mui/material";

import { setFigureFilter } from "~store/figures/actions";
import { selectSingleFilter } from "~store/figures/selectors";

const SelectFilter = ({ params, options: optionsProp = [], props = {} }) => {
  const dispatch = useDispatch();

  const filterName = useMemo(() => params?.[0], [params]);
  const selectedAgent = useSelector(selectSingleFilter(filterName));
  const options = useMemo(
    () =>
      optionsProp.map((option) => {
        return {
          label: option?.label || option?.value,
          value: option?.value,
        };
      }),
    [optionsProp]
  );

  const onSelect = (e, selected) => {
    dispatch(setFigureFilter({ [filterName]: selected }));
  };

  return (
    <PalPage>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PalAutoComplete isPrimitiveValue options={options} value={selectedAgent} onChange={onSelect} {...props} />
        </Grid>
      </Grid>
    </PalPage>
  );
};

export default SelectFilter;
